import type {GetDepartmentLinesSortOptionId} from '../../transport/apiService';

export const departmentJoinKeys = {
  all: ['departmentJoin'] as const,
  store: (storeId: string | null) => ['departmentJoin', storeId] as const,
  page: (
    storeId: string | null,
    departmentId: string,
    specials: boolean,
    page: number,
    sort: GetDepartmentLinesSortOptionId,
    keywords?: string,
    memberPrice?: 'public' | 'private',
  ) =>
    [
      ...departmentJoinKeys.store(storeId),
      departmentId,
      // DIS-1907: no keywords keeps the key unchanged. DIS-2007: likewise no memberPrice.
      {
        specials,
        page,
        sort,
        ...(keywords ? {keywords} : {}),
        ...(memberPrice ? {memberPrice} : {}),
      },
    ] as const,
};
